import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";

import { useAxios } from "../../../../hooks";
import FilterDataForm from "../../../leads/lead list components/FilterDataForm";

export default function FilterUser({
  editCondition,
  formikProps,
  filter,
  disable,
}) {
  const axios = useAxios();

  const [labels, setLabels] = useState([]);
  const [column, setColumn] = useState([]);
  const [memberList, setMemberList] = useState([]);

  const { bots, activeBot } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    if (filter) {
      axios({
        url: `/label/${activeBot.ID}`,
      }).then((response) => {
        if (response.status) {
          setLabels(response.data);
        }
      });

      axios({
        url: "/leads/members_list",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setMemberList(response.data);
        }
      });

      axios({
        url:
          "/custom_fields/get_fields_for_agent?agent_id=" +
          activeBot.ID +
          "&is_active=1",
        method: "GET",
      }).then((response) => {
        if (response.status) {
          let filterColumns = [
            {
              name: "name",
              label: "Name",
              dataType: "string",
            },
            {
              name: "email",
              label: "Email",
              dataType: "string",
            },
            {
              name: "phone",
              label: "Phone",
              dataType: "string",
            },
            {
              name: "created_by",
              label: "Created By",
              dataType: "string",
            },
          ];
          for (let field of response.data) {
            filterColumns.push({
              name: field.name,
              label: field.label,
              dataType: field.value_type,
              ...(field.control_id === "61dd2dfa1fb38be82e077ed8" && {
                options: field.options,
              }),
            });
          }
          setColumn(filterColumns);
        }
      });
    }
  }, [axios, filter, activeBot]);

  const [filterData, setFilterData] = useState({
    segmentName: formikProps.values.segmentName,
    filters: formikProps.values.segmentFilter || [
      {
        key: "",
        value: "",
        operator: "",
      },
    ],
    filtersLabels: formikProps.values.segmentLabels || [],
  });

  return (
    <Grid container spacing={2}>
      <FilterDataForm
        bots={bots}
        disable={editCondition}
        memberList={memberList}
        filterColumns={column}
        dialogFormikProps={formikProps}
      />
    </Grid>
  );
}
